



















































import {Component, Vue, Prop} from 'vue-property-decorator';
import { FilterData, FilterOption, Filter } from './filter/FilterTypes';

@Component({
  name: 'catalog-product-list-toolbar-active-filters'
})

export default class extends Vue {
  @Prop({required: true}) dataSource: string;
  private filterOpen: boolean = true;

  private get priceFacetCode(): null | string {
    const priceFilter = this.filters.find((f) => f.type === 'price');
    return priceFilter ? priceFilter.code : null;
  }

  private get filters(): Array<Filter> {
    let allFilters =  this.$store.getters[`${this.dataSource}/activeFilters`];

    return allFilters.filter(option => {
      return option.hasOwnProperty('options');
    })
  }

  private async resetFilters(): Promise<void> {
    // Reset price filter
    const options = {
      minPrice: 0,
      maxPrice: 10000,
    };

    this.$store.dispatch(`${this.dataSource}/updatePriceFilter`, options);

    await this.$store.dispatch(`${this.dataSource}/fetchCatalog`, {filters: []});



  }
  private get activeFilterResetUrl(): String {
    let activeFilters = this.$store.getters[`${this.dataSource}/activeFilters`] || [];

    for (const filter of activeFilters) {
      if (!filter.hasOwnProperty('options')) {
        continue;
      }

      for (const option of filter['options']) {
        if (option.active && (option['url'] ?? null) !== null) {
          const re: RegExp = /.*\//g;
          const result = re.exec(option['url']);
          return result !== null ? result[0] : option['url'];
        }
      }
    }

    return null;
  }

  private disableFilter(filter, option): void {

    this.$store.dispatch(`${this.dataSource}/toggleFilter`, {
      filter: filter,
      option: option,
    });
  }

  private async disableAllFilters(e): Promise<void> {
    e.preventDefault();
    const activeFiltersContainer = document.querySelector('.modal__content .toolbar__active-filters') as HTMLElement | null;
    if (activeFiltersContainer) { activeFiltersContainer.style.display = 'none'; }

    const allFilters = this.$store.getters[`${this.dataSource}/activeFilters`];
    await allFilters.forEach((filter) => {
      filter.options.forEach((option) => {
        if (option.active) {
          this.disableFilter(filter, option);
        }
      });
    });

    // Reset price filter
    const options = {
      minPrice: 0,
      maxPrice: 10000,
    };

    this.$store.dispatch(`${this.dataSource}/updatePriceFilter`, options);

  }



  private toggleFilter(): void {
    this.filterOpen = !this.filterOpen;
  }
}
